const swiper = new Swiper('.story-swiper', {
  slidesPerView: 1.5,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  breakpoints: {
    550: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4
    }
  }
});

const openModalContainer = document.querySelectorAll('.slide-with-popup');
const closeModalButtons1 = document.querySelectorAll('.modal-btn-close');
const modals1 = document.querySelectorAll('.card-modal-content');
const body = document.body;

const modalCache = {};

modals1.forEach(modal => {
  modalCache[modal.id] = modal;
  modal.remove();
});

let currentModal1 = null;

function openModal(modal) {
  body.appendChild(modal);
  modal.classList.add('active');
  body.classList.add('no-scroll');
  currentModal1 = modal;
}

function closeModal(modal) {
  modal.classList.remove('active');
  body.classList.remove('no-scroll');
  modal.remove();
  currentModal1 = null;
}

openModalContainer.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    const modalId = button.getAttribute('data-target').replace('#', '');
    const targetModal = modalCache[modalId];
    if (targetModal) {
      openModal(targetModal);
    }
  });
});

closeModalButtons1.forEach(button => {
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    if (currentModal1) {
      closeModal(currentModal1);
    }
  });
});
modals1.forEach(modal => {
  modal.addEventListener('click', (event) => {
    event.stopPropagation();
    console.log('clickedddd!!!');
    if (currentModal1) {
      closeModal(currentModal1);
    }
  });
});

document.addEventListener('click', (event) => {
  if (currentModal1 && !currentModal1.contains(event.target)) {
    closeModal(currentModal1);
  }
});

// const openModalContainer = document.querySelectorAll('.slide-with-popup');
// const closeModalButtons1 = document.querySelectorAll('.modal-btn-close');
// const modals1 = document.querySelectorAll('.card-modal-content');
// const holders1 = document.querySelectorAll('.card-modal--holder');
// const popupContent = document.querySelectorAll('.modal-content-w');
// const body = document.body;

// let currentModal1 = null;

// function openModal(modal) {
//   modal.classList.add('active');
//   body.classList.add('no-scroll');
//   currentModal1 = modal;
// }

// function closeModal(modal) {
//   modal.classList.remove('active');
//   body.classList.remove('no-scroll');
//   currentModal1 = null;
// }

// openModalContainer.forEach(button => {
//   button.addEventListener('click', (event) => {
//     event.stopPropagation();
//     const targetModal = document.querySelector(button.getAttribute('data-target'));
//     if (targetModal) {
//       openModal(targetModal);
//     }
//   });
// });

// closeModalButtons1.forEach(button => {
//   button.addEventListener('click', (event) => {
//     event.stopPropagation();
//     if (currentModal1) {
//       closeModal(currentModal1);
//     }
//   });
// });

// modals1.forEach(modal => {
//   modal.addEventListener('click', (event) => {
//     event.stopPropagation();
//     if (currentModal1) {
//       closeModal(currentModal1);
//     }
//   });
// });

// document.addEventListener('click', (event) => {
//   if (currentModal1 && !currentModal1.contains(event.target)) {
//     closeModal(currentModal1);
//   }
// });

// holders1.forEach(holder => {
//   holder.addEventListener('click', (event) => {
//     event.stopPropagation();
//   });
// });

// document.querySelectorAll('.wide-card-container').forEach((element) => {
//   const closestHolder = element.closest('.card-modal--holder');
//   if (closestHolder) {
//       closestHolder.classList.add('full-width');
//   }
// });